import { Map } from "immutable";
import TYPE from "../../constants/type";

const initialState = Map({
  list: [],
  listById: [],
  listFiltered: [],
  listDuplicate: [],
  isFetching: false,
  isFetchingAccepted: false,
});

const scientificCouncilNewReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_LOADING:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.GET_FILTERED_SCIENTIFIC_COUNCIL_LOADING:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_BY_PROFILE_ID_LOADING:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.INSERT_SCIENTIFIC_COUNCIL_LOADING:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.UPDATE_SCIENTIFIC_COUNCIL_LOADING:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.DELETE_SCIENTIFIC_COUNCIL_LOADING:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.EXPORT_SCIENTIFIC_COUNCIL_LOADING:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.CHECK_DUPLICATE_SCIENTIFIC_COUNCIL_LOADING:
      return state.set("isFetching", true);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.ACCEPT_SCIENTIFIC_COUNCIL_LOADING:
      return state.set("isFetchingAccepted", true);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_SUCCESS:
      return state.set("list", action.payload).set("isFetching", false);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.GET_FILTERED_SCIENTIFIC_COUNCIL_SUCCESS:
      return state.set("listFiltered", action.payload).set("isFetching", false);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_BY_PROFILE_ID_SUCCESS:
      return state.set("listById", action.payload).set("isFetching", false);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.INSERT_SCIENTIFIC_COUNCIL_SUCCESS:
      return state
        .set("listById", [...state.get("listById"), action.payload])
        .set("list", [...state.get("list"), action.payload])
        .set("isFetching", false);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.UPDATE_SCIENTIFIC_COUNCIL_SUCCESS:
      return state
        .set(
          "listById",
          state.get("listById").map((item) => (item.id === action.payload.id ? action.payload : item)),
        )
        .set(
          "list",
          state.get("list").map((item) => (item.id === action.payload.id ? action.payload : item)),
        )
        .set(
          "listFiltered",
          state.get("listFiltered").map((item) => (item.id === action.payload.id ? action.payload : item)),
        )
        .set("isFetching", false);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.DELETE_SCIENTIFIC_COUNCIL_SUCCESS:
      return state
        .set(
          "listById",
          state.get("listById").filter((item) => item.id !== action.payload),
        )
        .set(
          "list",
          state.get("list").filter((item) => item.id !== action.payload),
        )
        .set(
          "listFiltered",
          state.get("listFiltered").filter((item) => item.id !== action.payload),
        )
        .set("isFetching", false);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.ACCEPT_SCIENTIFIC_COUNCIL_SUCCESS:
      return state
        .set(
          "listById",
          state.get("listById").map((item) => (item.id === action.payload.id ? action.payload : item)),
        )
        .set(
          "list",
          state.get("list").map((item) => (item.id === action.payload.id ? action.payload : item)),
        )
        .set(
          "listFiltered",
          state.get("listFiltered").map((item) => (item.id === action.payload.id ? action.payload : item)),
        )
        .set("isFetchingAccepted", false);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.EXPORT_SCIENTIFIC_COUNCIL_SUCCESS:
      return state.set("isFetching", false);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.CHECK_DUPLICATE_SCIENTIFIC_COUNCIL_SUCCESS:
      return state.set("listDuplicate", action.payload).set("isFetching", false);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_FAILURE:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.GET_FILTERED_SCIENTIFIC_COUNCIL_FAILURE:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.GET_ALL_SCIENTIFIC_COUNCIL_BY_PROFILE_ID_FAILURE:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.INSERT_SCIENTIFIC_COUNCIL_FAILURE:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.UPDATE_SCIENTIFIC_COUNCIL_FAILURE:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.DELETE_SCIENTIFIC_COUNCIL_FAILURE:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.EXPORT_SCIENTIFIC_COUNCIL_FAILURE:
    case TYPE.SCIENTIFIC_COUNCIL_NEW.CHECK_DUPLICATE_SCIENTIFIC_COUNCIL_FAILURE:
      return state.set("isFetching", false);

    case TYPE.SCIENTIFIC_COUNCIL_NEW.ACCEPT_SCIENTIFIC_COUNCIL_FAILURE:
      return state.set("isFetchingAccepted", false);

    default:
      return state;
  }
};

export default scientificCouncilNewReducer;

